module.exports = __webpack_public_path__ + "static/media/Chapter 4 Slide 1.ed60f25a.jpg";